import { ChainId } from "@usedapp/core";
import axios from "../core/https";
import { ICollection } from "../core/models/collection";
import { INft } from "../core/models/nft";
import { ISale } from "../core/models/order";
import { IUser } from "../core/models/user";
import { getIpAddressClient } from "../core/utils/getIpAddressClient";

const saveDraft = (body: INft) => axios.post("/marketplace/nfts", body);

const confirm = (id: string) =>
  axios.put(
    `/marketplace/nfts/${id}/confirm`,
    {},
    {
      headers: {
        requireToken: "0",
      },
    }
  );
const delist = (id: string) => axios.put(`/marketplace/nfts/${id}/delist`);

const sync = (tokenAddress: string, tokenId: string, ownerOf: string) =>
  axios.put(
    `/marketplace/nfts/${tokenAddress}/${tokenId}/${ownerOf}/sync`,
    {},
    {
      headers: {
        requireToken: "0",
      },
    }
  );

const getOrders = (params: {
  seller?: string;
  buyer?: string;
  sort_field?: string;
  sort_direction?: string;
  page?: number;
  size?: number;
}) =>
  axios.get<ISale[]>(`/marketplace/orders`, {
    params,
  });

const quickSearch = (params: {
  name: string;
  sort_field?: string;
  sort_direction?: string;
  page?: number;
  size?: number;
  collection?: string;
  account?: string | null | undefined;
}) =>
  axios.get<INft[]>(`/marketplace/nfts/quick-search`, {
    headers: {
      requireToken: "0",
    },
    params,
  });

const getViews = async (
  tokenAddress: string,
  tokenId: string,
  account: string | null | undefined,
  chainId?: ChainId
) => {
  const ipResponse = await getIpAddressClient();
  const ipAddress = ipResponse.data.ip || "";
  return axios.post<number>(
    `/marketplace/nfts/count-view`,
    {
      type: 0,
      token_address: tokenAddress,
      token_id: tokenId,
      account: account,
      chain_id: chainId,
    },
    {
      headers: {
        requireToken: "0",
        "X-Client-IP": ipAddress,
      },
    }
  );
};

const getTopCollections = (params?: { filter_day?: number }) =>
  axios.get<ICollection[]>(`/marketplace/nfts/top-collection`, {
    headers: {
      requireToken: "0",
    },
    params
  });

const getTopFavoriteNfts = () =>
  axios.get<INft[]>(`/marketplace/nfts/top-nft-favorite`, {
    headers: {
      requireToken: "0",
    },
  });

const getTopUsers = (params?: { filter_day?: number; group_by_buyer?: boolean }) =>
  axios.get<IUser[]>(`/marketplace/nfts/top-sale-nft`, {
    headers: {
      requireToken: "0",
    },
    params
  });

export const marketplaceService = {
  saveDraft,
  confirm,
  delist,
  sync,
  getOrders,
  quickSearch,
  getViews,
  getTopCollections,
  getTopFavoriteNfts,
  getTopUsers,
};
